import React from 'react'
import {browserHistory, Route, Router} from 'react-router'

import MinatureContact from './Page/MinatureContact'
import RelationEtablissement from './Page/RelationEtablissement'
import UploadGoogleStorage from './Page/UploadGoogleStorage'
import Voeux from './Page/Voeux'
import Unsubscribe from './Page/Unsubscribe'
import SlackDeleteFile from './Page/SlackDeleteFile'
import Emailing2019 from './Page/Emailing2019'
import ModificationMotDePasse from './Page/ModificationMotDePasse'
import Test from './Page/Test'

export default _ =>
  <Router history={browserHistory}>
    <Route path="/page/contact/:id" component={MinatureContact}/>
    <Route path="/page/etablissement/relation" component={RelationEtablissement}/>
    <Route path="/page/slack/file/delete" component={SlackDeleteFile}/>
    <Route path="/page/voeux" component={Voeux}/>
    <Route path="/page/unsubscribe/:key" component={Unsubscribe}/>
    <Route path="/page/emailing" component={Emailing2019}/>
    <Route path="/page/etablissement/upload" component={UploadGoogleStorage}/>
    <Route path="/page/modification/password/:key_generator" component={ModificationMotDePasse}/>
    <Route path="/page/test" component={Test}/>
  </Router>



// WEBPACK FOOTER //
// ./app/App/Module/Page/index.js